import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    openTranslation: String,
    closeTranslation: String
  }

  connect() {
    this.revealsAreOpen = false
  }

  toggleAllReveals(e) {
    e.preventDefault()

    this.revealsAreOpen = !this.revealsAreOpen
    this.element.querySelectorAll("[data-reveal-target=\"item\"]").forEach((element) => {
      element.classList.toggle("d-none", !this.revealsAreOpen)
    })
    this.updateButtonText(e.currentTarget)
  }

  updateButtonText(button) {
    if (this.revealsAreOpen) {
      button.innerText = this.closeTranslationValue
    } else {
      button.innerText = this.openTranslationValue
    }
  }
}
